// Core
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FILTER_TYPES } from '../constants';

// Components
import { GECKO_CONSTS, GeckoBtns, GeckoForm, GeckoFormField } from 'ui';

// Styles
import './index.css';

const fieldsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    key: PropTypes.string,
    type: PropTypes.oneOf(Object.values(FILTER_TYPES)),
    label: PropTypes.string,
    choices: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.element,
        value: PropTypes.string,
      })
    ),
  })
);

class QuickSearch extends Component {
  static propTypes = {
    filters: fieldsPropType,
    filterButtonName: PropTypes.string,
    showExpandButton: PropTypes.bool,
    expanded: PropTypes.bool,
    onToggle: PropTypes.func,
  };

  static defaultProps = {
    filters: [],
    filterButtonName: 'Filter',
    showExpandButton: false,
    onToggle: () => {},
    expanded: true,
  };

  renderSearchField() {
    const initialSearchValue = this.props.select ? {} : '';
    const placeholder = 'Search';
    const name = 'search';
    return (
      <GeckoForm
        initialValues={{ search: initialSearchValue }}
        onSubmit={({ search }) => this.props.onSearch(search)}
      >
        {({ handleSubmit }) => (
          <>
            {this.props.select ? (
              <GeckoFormField
                fieldType="search_select"
                name={name}
                placeholder={placeholder}
                onValueChange={handleSubmit}
                getOptions={(searchValue) => [
                  {
                    label: `Message contains: ${searchValue}`,
                    value: 'message',
                  },
                  {
                    label: `Closest Match contains: ${searchValue}`,
                    value: 'closest_match',
                  },
                ]}
              />
            ) : (
              <GeckoFormField
                fieldType="search"
                name={name}
                placeholder={placeholder}
              />
            )}
          </>
        )}
      </GeckoForm>
    );
  }

  render() {
    let buttons = [
      {
        icon: 'far fa-sliders-h',
        name: this.props.filterButtonName,
        type: this.props.filters.length
          ? GECKO_CONSTS.BTN_TYPE_PRIMARY
          : GECKO_CONSTS.BTN_TYPE_DEFAULT,
        handler: this.props.onToggle,
      },
    ];

    return (
      <div className="QuickSearch">
        <div style={{ paddingLeft: '10px', paddingRight: '10px' }}>
          <GeckoBtns items={buttons} />
        </div>
        {this.renderSearchField()}
      </div>
    );
  }
}

export default QuickSearch;
